import * as React from "react";
import { subjektFormatter } from "@mc/mc-legacy";
import { i18n } from "../../i18n/i18n";
export function formatJmenoPrijmeni(userInfo, lang) {
  let result;

  if (userInfo.jmeno) {
    result = userInfo.jmeno;
  }

  if (userInfo.prijmeni) {
    if (result) {
      result += " ";
    }

    result += userInfo.prijmeni;
  }

  if (!userInfo.jmeno && !userInfo.prijmeni) {
    result = <i>{i18n(lang, "ProcessLoginPage_nodata_jmenoPrijmeni")}</i>;
  }

  return result;
}
export function formatAdresa(userInfo, lang) {
  return (
    (userInfo.adresa && subjektFormatter.getAdresa(userInfo.adresa)) || (
      <i></i>
    )
  );
}
